<template>
  <div class="period-toggle flex items-center">
    <vx-tooltip text="Go back to current month" v-visible="!isCurrentMonth">
      <feather-icon
        :icon="selectedMonthPast ? 'ChevronsRightIcon' : 'ChevronsLeftIcon'"
        svgClasses="w-5 h-5 m-1"
        class="cursor-pointer rounded-full"
        @keyup.left="updateMonth(-1)"
        @click="goToCurrentMonth"
      />
    </vx-tooltip>
    <feather-icon
      :icon="$vs.rtl ? 'ChevronRightIcon' : 'ChevronLeftIcon'"
      svgClasses="w-5 h-5 m-1"
      class="cursor-pointer bg-primary text-white rounded-full"
      @keyup.left="updateMonth(-1)"
      @click="updateMonth(-1)"
    />
    <span
      class="period-toggle__month whitespace-no-wrap text-center font-semibold"
    >
      {{ selectedMonth | monthYear }}
    </span>

    <feather-icon
      :icon="$vs.rtl ? 'ChevronLeftIcon' : 'ChevronRightIcon'"
      svgClasses="w-5 h-5 m-1"
      class="cursor-pointer bg-primary text-white rounded-full"
      @click="updateMonth(1)"
    />
  </div>
</template>
<script>
import {isCurrentPeriod, currentPeriod, isPastPeriod} from '@/helpers/date'

export default {
  async mounted () {
    // TODO: may bring problems in the future
    // await this.$store.dispatch('RESET_CURRENT_PERIOD')
  },
  computed: {
    selectedMonth () {
      return this.$store.getters.currentPeriod
    },
    isCurrentMonth () {
      return isCurrentPeriod(this.selectedMonth)
    },
    currentPeriod () {
      return currentPeriod()
    },
    selectedMonthPast () {
      return isPastPeriod(this.selectedMonth)
    }
  },
  methods: {
    updateMonth (monthDiff) {
      const current = new Date(this.selectedMonth)
      const month = new Date(current.getFullYear(), current.getMonth() + monthDiff, 1)
      this.$store.dispatch('SET_CURRENT_PERIOD', month)
    },
    goToCurrentMonth () {
      this.$store.dispatch('SET_CURRENT_PERIOD', this.currentPeriod)
    }
  }
}
</script>
<style lang="scss">
.period-toggle {
  &__month {
    width: 200px;
    font-size: 1.5rem;
  }
}
</style>
